import Store from "../../../../Store/Store";

class AssignmentServiceStatusTypeContainer {
  public pickIdFromLabel(label) {
    const AssignmentServiceStatusType = Store.getConfigurator().getState().globalTypes?.AssignmentServiceStatus

    for (const key in AssignmentServiceStatusType) {
      if (AssignmentServiceStatusType[key].label.toLowerCase() === label.toLowerCase()) {
        return AssignmentServiceStatusType[key].id
      }
    }
  }

  public pickLabelFromId(id) {
    const AssignmentServiceStatusType = Store.getConfigurator().getState().globalTypes?.AssignmentServiceStatus

    for (const key in AssignmentServiceStatusType) {
      if (AssignmentServiceStatusType[key].id === id) {
        return AssignmentServiceStatusType[key].label
      }
    }
  }
}

export default new AssignmentServiceStatusTypeContainer();
